import { HStack, Icon, StackTypes, Text, VStack } from '@genial/components';
import React from 'react';

import { SecuritiesTransferDetailItemNormalized } from '../../../../../../../../../store/customerDetail/SecuritiesTransfer/types';
import { LogoWithName, LogoWithNameLoading } from '../LogoWithName';

interface SourceAndDestinationDefaultProps {
  w?: StackTypes.Props['w'];
}

type SourceAndDestinationProps = Pick<
  SecuritiesTransferDetailItemNormalized,
  'sourceLogoUrl' | 'sourceNameNormalized' | 'destinationLogoUrl' | 'destinationNameNormalized'
> &
  SourceAndDestinationDefaultProps;

export const SourceAndDestination: React.FC<SourceAndDestinationProps> = ({
  w,
  sourceLogoUrl,
  sourceNameNormalized,
  destinationLogoUrl,
  destinationNameNormalized,
}) => {
  return (
    <HStack flex={1} maxW={w} alignItems="center" justifyContent="space-between">
      <VStack space="stack.quarck" w="2/5">
        <Text>De</Text>
        <LogoWithName logoUrl={sourceLogoUrl} name={sourceNameNormalized} />
      </VStack>
      <Icon name="ArrowRight" size="xs" color="neutral.light" />
      <VStack space="stack.quarck" w="2/5">
        <Text>Para</Text>
        <LogoWithName logoUrl={destinationLogoUrl} name={destinationNameNormalized} />
      </VStack>
    </HStack>
  );
};

export const SourceAndDestinationLoading: React.FC<SourceAndDestinationDefaultProps> = ({ w }) => {
  return (
    <HStack flex={1} maxW={w} alignItems="center" justifyContent="space-between">
      <VStack space="stack.quarck" w="2/5">
        <Text variant="semibold">De</Text>
        <LogoWithNameLoading />
      </VStack>
      <Icon name="ArrowRight" size="xs" color="neutral.light" />
      <VStack space="stack.quarck" w="2/5">
        <Text variant="semibold">Para</Text>
        <LogoWithNameLoading />
      </VStack>
    </HStack>
  );
};
